// SHIM - alias na './listings'. Generovane skriptom
// /var/www/claude-tools/realico-portal-postgen.cjs (docasne, viz komentar tam).
export * from './listings';
